import { render, staticRenderFns } from "./Invoice.vue?vue&type=template&id=0f852bae&scoped=true&"
import script from "./Invoice.vue?vue&type=script&lang=ts&"
export * from "./Invoice.vue?vue&type=script&lang=ts&"
import style0 from "./Invoice.vue?vue&type=style&index=0&id=0f852bae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f852bae",
  null
  
)

export default component.exports